<div class="tall">
  <app-header [class.scrolled]="isScrolled"></app-header>
  <div #scrollableContainer class="tall-container">
    @if (showStepper()) {
      <app-acs-stepper></app-acs-stepper>
    }
    <div class="p-5 bg-primary">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>

  @if (isGlobalLoading()) {
    <div class="app-global-loader-overlay" aria-live="polite" aria-busy="true">
      <div class="app-global-loader-content">
        <mat-icon class="loading">refresh</mat-icon>
        <span>{{ 'key.loading' | translate }}</span>
      </div>
    </div>
  }
</div>
